class RatingStars {
	constructor(ratingComponent) {
		this.ratingComponent = ratingComponent;
		this.stars = Array.from(this.ratingComponent.querySelectorAll('.js-gw-rating-stars__star'));
		this.hasRated = false;

		if (this.stars.length === 0) {
			return;
		}

		this.bindEvents();
	}

	bindEvents() {
		this.stars.forEach((star) => {
			const rating = Number(star.dataset.rating || 0);

			star.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault();
					star.click();
				}
			});

			star.addEventListener('click', () => {
				if (this.hasRated) {
					return;
				}

				const category = 'Angebot bewerten';
				const name = this.ratingComponent.dataset.partnername || 'unknown';
				const action = 'click';

				
				if (typeof _paq !== 'undefined') {
					_paq.push(['trackEvent', category, action, name, rating]);
				}

				this.hasRated = true;
				this.ratingComponent.classList.add('gw-rating-stars--done');
			});
		});
	}
}

export default RatingStars;
